// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ModalOnLoadController from "./modal_on_load_controller"
application.register("modal-on-load", ModalOnLoadController)
